module.exports = __webpack_public_path__ + "img/Happy-Sun-drawing.99462c3b.png";